import { useState } from 'react';
import {
  addToArray,
  filterOutValue,
  filterOutValues,
  mergeWithoutDuplicates,
} from '@witmetrics/utils/arrays';

export function useIds<T extends number | string = number>(
  initialIds: T[] = []
) {
  const [ids, setIds] = useState(initialIds);

  const addId = (id: T) => {
    setIds((ids) => addToArray(ids, id));
  };

  const addIds = (newIds: T[]) => {
    setIds((ids) => mergeWithoutDuplicates(ids, newIds));
  };

  const removeId = (id: T) => {
    setIds((ids) => filterOutValue(ids, id));
  };

  const removeIds = (removedIds: T[]) => {
    setIds((ids) => filterOutValues(ids, removedIds));
  };

  const toggleId = (id: T) => {
    setIds((ids) =>
      ids.includes(id) ? filterOutValue(ids, id) : addToArray(ids, id)
    );
  };

  const clearIds = () => {
    setIds([]);
  };

  const resetIds = () => {
    setIds(initialIds);
  };

  return [
    ids,
    setIds,
    {
      clear: clearIds,
      reset: resetIds,
      addId,
      addIds,
      removeId,
      removeIds,
      toggleId,
    },
  ] as const;
}
